import React from "react";

function currentPeriod() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function useDefaultPeriod() {
  return currentPeriod();
}

export default function PeriodPicker({ value, onChange, monthsBack = 12 }) {
  const options = [];
  const d = new Date();
  for (let i = 0; i < monthsBack; i++) {
    const y = d.getFullYear();
    const m = d.getMonth() + 1;
    options.push(`${y}-${String(m).padStart(2, "0")}`);
    d.setMonth(d.getMonth() - 1);
  }
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map((p) => (
        <option key={p} value={p}>
          {p}
        </option>
      ))}
    </select>
  );
}
